import type {ContentPanelParams, ContentPanelContextValue} from '@jetbrains/teamcity-ui'
import {useMemo, useState} from 'react'

import {useSyncedBooleanQueryParam} from '../../../hooks/routes'
import type {UserProperty} from '../../../utils/userProperties'

export function useContentPanelContextValue(): ContentPanelContextValue {
  const [params, setParams] = useState<ContentPanelParams>({panelType: '', expandedByDefault: true})
  const {panelType, expandedByDefault} = params
  const [expanded, setExpanded] = useSyncedBooleanQueryParam({
    skip: !panelType,
    param: panelType,
    userProperty: panelType as UserProperty,
    defaultTrue: expandedByDefault,
  })

  return useMemo(
    () => ({
      expanded,
      setExpanded,
      setParams,
    }),
    [expanded, setExpanded, setParams],
  )
}
